import { render, staticRenderFns } from "./pdf.vue?vue&type=template&id=2c60c3a1"
import script from "./pdf.vue?vue&type=script&lang=ts"
export * from "./pdf.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports